<template>
    <div @click.prevent.stop="openCertificate" title="Certificate" v-bind="$attrs" v-if="canShowCert">
        <certificate-icon class="h-6" />
    </div>
    <a
        :href="`/external-course-certificate-download/${externalCourseUserId}`"
        download="download"
        title="Download Certificate"
        v-bind="$attrs"
        v-else
    >
        <certificate-icon class="h-6" />
    </a>
    <teleport to="body">
        <div v-if="preparingCertificate">
            <spinner-message v-if="pdfDownloading" message="It can take a couple of seconds for the PDF to generate.">
                <button @click="pdfDownloading = false">
                    Please Click here after the PDF has downloaded, if this message doesn't close on it's own.
                </button>
            </spinner-message>
            <spinner-message v-if="!showCertificate" message="Generating and Downloading Certificate..." />
            <div
                class="p-10 pt-4 fixed inset-0 bg-black bg-opacity-80 
                flex flex-row flex-wrap justify-center items-center z-40"
                @click="closeCertificate"
            >
                <close-button @clicked="closeCertificate" />
                <div class="w-full text-center" @click.stop="">
                    <a
                        class="inline-block btn btn-primary mb-4"
                        :href="`/external-course-certificate-download/${externalCourseUserId}`"
                        @click="initiatePdfDownload"
                        download="download"
                        >Download PDF</a
                    >
                </div>
                <div
                    class="bg-white w-11/12  h-full 
                    flex flex-row justify-center items-center"
                >
                    <iframe
                        :src="`/external-course-certificate/${externalCourseUserId}`"
                        class="w-full h-full"
                        @load="showCertificate = true"
                    />
                </div>
            </div>
        </div>
    </teleport>
</template>

<script>
import CertificateIcon from "@/components/icons/CertificateIcon";
import CloseButton from "@/components/utilities/CloseButton.vue";

/**
 * Note: at this time mobiles do not support displaying pdf's inline, also the certificates use a fixed width
 * bigger than mobile screens
 * here we're detecting the screen width and showing view cert button to large screens, this opens the cert with a download button
 * for small screens we just show a download button
 */

export default {
    name: "ExternalCourseCertificate",
    components: { CertificateIcon, CloseButton },
    props: {
        externalCourseUserId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            preparingCertificate: false,
            showCertificate: false,
            pdf: null,
            pdfDownloading: false
        };
    },
    computed: {
        canShowCert() {
            return window.innerWidth > 767;
        }
    },
    methods: {
        openCertificate() {
            this.preparingCertificate = true;
        },
        closeCertificate() {
            this.showCertificate = false;
            this.$nextTick(() => {
                this.preparingCertificate = false;
            });
        },
        initiatePdfDownload() {
            window.addEventListener("blur", this.hidePdfDownloading, false);
            this.pdfDownloading = true;
        },
        hidePdfDownloading() {
            window.removeEventListener("blur", this.hidePdfDownloading, false);
            this.pdfDownloading = false;
        }
    }
};
</script>
